import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import Header from './components/Header';
import HeroSection from './components/sections/HeroSection';
import ProblemSection from './components/sections/ProblemSection';
import SolutionSection from './components/sections/SolutionSection';
import FeaturesSection from './components/sections/FeaturesSection';
import SecuritySection from './components/sections/SecuritySection';
import FaqSection from './components/sections/FaqSection';
import TestimonialsSection from './components/sections/TestimonialsSection';
import Footer from './components/Footer';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Header />
      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <FeaturesSection />
      <SecuritySection />
      <FaqSection />
      <TestimonialsSection />
      <Footer />
    </ThemeProvider>
  );
}

export default App;
